import { render } from "./AddExpenseTransaction.vue?vue&type=template&id=4ea62f41"
import script from "./AddExpenseTransaction.vue?vue&type=script&lang=js"
export * from "./AddExpenseTransaction.vue?vue&type=script&lang=js"

import exportComponent from "/srv/amodomo.com/shared/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])